import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDownload = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M6 18h12v-3h2v3q0 .825-.588 1.412A1.93 1.93 0 0 1 18 20H6q-.824 0-1.412-.588A1.93 1.93 0 0 1 4 18v-3h2zm7-5.85 2.6-2.6L17 11l-5 5-5-5 1.4-1.45 2.6 2.6V4h2z" })
});
export default SvgDownload;
